// Overview.js
import React, { useState, useReducer, useEffect } from "react";
import { Box, Container, IconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useParams } from "react-router-dom";
import SplitterLayout from "react-splitter-layout";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import TemplateBox from "components/TemplateBox";
import Contacts from "../Contacts";
import AlarmDetailsContent from "../AlarmDetailsContent";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import CallSplitIcon from "@mui/icons-material/CallSplit";
import { fetchSingleAlarm } from "../../apiService";
import { Card, CardContent, Typography, Stack } from "@mui/material";
function Overview() {
  const { alarmID } = useParams();
  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "en"
  );
  const [showPopup, setShowPopup] = useState(false);

  const handlePopUpButtonClick = () => {
    setShowPopup(!showPopup);
  };

  const theme = useTheme();
  const mobileDevice = !useMediaQuery(theme.breakpoints.up("md"));

  const initialState = {
    data: null,
    loading: true,
    error: null,
  };

  function reducer(state, action) {
    switch (action.type) {
      case "DATA_RECEIVED":
        return { ...state, data: action.value, loading: false };
      case "ERROR":
        return { ...state, error: action.error, loading: false };
      default:
        return state;
    }
  }

  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchSingleAlarm(alarmID, language);
        dispatch({ type: "DATA_RECEIVED", value: response });
      } catch (error) {
        dispatch({ type: "ERROR", error });
      }
    };
    fetchData();
  }, [alarmID, language]);

  const { data, loading, error } = state;

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar
          absolute
          light
          language={language}
          setLanguage={setLanguage}
        />
        <TemplateBox sx={{ pt: 2 }}>
          <SplitterLayout
            vertical={mobileDevice}
            percentage={true}
            primaryMinSize={50}
            secondaryMinSize={20}
            secondaryInitialSize={50}
            customClassName="splitter-layout-custom"
          >
            <div>
              <TemplateBox height="15px" />
              <Box
                sx={{
                  position: "absolute",
                  top: 16,
                  right: 16,
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <IconButton color="primary" onClick={() => handlePopUpButtonClick()}
                >
                  <CallSplitIcon />
                </IconButton>
              </Box>

              <Container maxWidth="lg">
                {!loading && !error && data && data[0] ? (
                  <AlarmDetailsContent data={data[0]} language={language}/>
                ) : loading ? (
                  <AlarmDetailsContent loading data={[]} language={language}/>
                ) : (
                  <AlarmDetailsContent data={[]} language={language}/>
                )}

                {error && <div>Error: {error.message}</div>}
              </Container>
            </div>

            {!loading && showPopup && data && data[0] && (
              <Contacts
                isOpen={showPopup}
                onClose={() => setShowPopup(false)}
                rowData={data}
              />
            )}
            {loading && showPopup && <Contacts loading />}
          </SplitterLayout>
        </TemplateBox>
      </DashboardLayout>
    </>
  );
}

export default Overview;
